var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.904 13.0506L13.7827 15.1719L19.7789 21.1681L21.9002 19.0468L15.904 13.0506Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 9.9998C19.4301 9.9998 21.0001 8.4298 21.0001 6.4998C21.0001 5.9198 20.8401 5.3798 20.5901 4.8998L17.8901 7.5998L16.4001 6.1098L19.1001 3.4098C18.6201 3.1598 18.0801 2.9998 17.5001 2.9998C15.5701 2.9998 14.0001 4.5698 14.0001 6.4998C14.0001 6.9098 14.0801 7.2998 14.2101 7.6598L12.3601 9.5098L10.5801 7.7298L11.2901 7.0198L9.8801 5.6098L12.0001 3.4898C10.8301 2.3198 8.9301 2.3198 7.7601 3.4898L4.2201 7.0298L5.6301 8.4398H2.8101L2.1001 9.1498L5.6401 12.6898L6.3501 11.9798V9.1498L7.7601 10.5598L8.4701 9.8498L10.2501 11.6298L2.8401 19.0398L4.9601 21.1598L16.3401 9.7898C16.7001 9.9198 17.0901 9.9998 17.5001 9.9998Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolSelected);
export default __webpack_public_path__ + "static/media/ToolSelected.5b6428fa5dd22aa530453b5ef7a6f3cd.svg";
export { ForwardRef as ReactComponent };